import React from 'react';
import './../App.css';
import XP55Hull from './XP55Hull';
import { Route, Switch, Redirect  } from "react-router-dom";
import XP55BowSprit from './XP55BowSprit';
import XP55HullTreatment from './XP55HullTreatment';
import XP55Transom from './XP55Transom';
import XP55Deck from './XP55Deck';
import XP55Sprayhood from './XP55Sprayhood';
import XP55Wheel from './XP55Wheel';
import XP55Mast from './XP55Mast';
import XP55Interior from './XP55Interior';
import XP55Galley from './XP55Galley';
import XP55Fabric from './XP55Fabric';
import XP55OwnersCabin from './XP55OwnersCabin';
import XP55AftCabin from './XP55AftCabin';
import Logo from './XP55-logo.svg';
import XP55Summary from './XP55Summary';
import XP55BathingPlatform from './XP55BathingPlatform';

import hullColor11 from '../assets/hullColors/Hull colour -  pure white RAL 9010 & 3 x light grey RAL 7035 waterliness.jpg';
import hullColor12 from '../assets/hullColors/Hull colour -  pure white RAL 9010 & 3 x black grey RAL 702 waterlines.jpg';
import hullColor17 from '../assets/hullColors/Hull colour - pure white RAL 9010 & pastel blue RAL 5024 & 3 x  waterlines.jpg';
import hullColor14 from '../assets/hullColors/Hull colour - light grey RAL 7035 & 3 x pure white RAL 9010 waterlines.jpg';
import hullColor15 from '../assets/hullColors/Hull colour - black grey RAL 7021 & 3 x pure white RAL 9010 waterlines.jpg';
import hullColor16 from '../assets/hullColors/Hull colour - pastel blue RAL 9010 & 3 x pure white RAL 9010 waterlines.jpg';

import fabric1 from '../assets/fabrics/JustFleckless–01Nature.jpg';
import fabric2 from '../assets/fabrics/JustFleckless–05Camel.jpg';
import fabric3 from '../assets/fabrics/JustFleckless–10Navy.jpg';
import fabric4 from '../assets/fabrics/JustFleckless–403Bambus.jpg';
import fabric5 from '../assets/fabrics/JustFleckless–710MoonGrey.jpg';
import fabric6 from '../assets/fabrics/JustFleckless–750OliveGrey.jpg';
import fabric7 from '../assets/fabrics/AlsaceBlue.jpg';
import fabric8 from '../assets/fabrics/AlsaceIvory.jpg';
import fabric9 from '../assets/fabrics/AlsaceSand.jpg';
import fabric10 from '../assets/fabrics/Nubilux709Argent.jpg';

import galley1 from '../assets/galleyColors/camoan_white_corian.jpg';
import galley2 from '../assets/galleyColors/black_quartz_corian.jpg';

import veneer1 from '../assets/interiorColors/nordic_oak.jpg';
import veneer2 from '../assets/interiorColors/teak.jpg';

import laminate1 from '../assets/interiorColors/teak_without_koto.jpg';
import laminate2 from '../assets/interiorColors/walnut.jpg';
import laminate3 from '../assets/interiorColors/teak_with_koto.jpg';

import sprayhood1 from '../assets/sprayhoodColors/without.jpg';
import sprayhood2 from '../assets/sprayhoodColors/Dark grey.jpg';
import sprayhood3 from '../assets/sprayhoodColors/Taupe.jpg';
import sprayhood4 from '../assets/sprayhoodColors/Captains blue.jpg';
import sprayhood5 from '../assets/sprayhoodColors/Silver grey.jpg';

import ConfiguratorContainer from '../ConfiguratorContainer';
import { withTranslation } from 'react-i18next';

class XP55Container extends ConfiguratorContainer {
    constructor(props) {
        super(props);

        this.logo = Logo;
        this.logoLink = 'https://www.x-yachts.com/en/yachts/xp/xp-55/';

        this.HullColourOptions = [
            { value: 1, label: this.props.t('Pure White'), description: this.props.t('(RAL 9010) & 3 x Pastel Blue (RAL 5024) integrated Gelcoat Water Lines'), preview: hullColor17 },
            { value: 2, label: this.props.t('Pure White'), description: this.props.t('(RAL 9010) & 3 x Black Grey (RAL 7021) integrated Gelcoat Water Lines'), preview: hullColor12 },
            { value: 3, label: this.props.t('Pure White'), description: this.props.t('(RAL 9010) & 3 x Light Grey (RAL 7035) integrated Gelcoat Water Lines'), preview: hullColor11 },
            { value: 6, label: this.props.t('Pastel Blue'), description: this.props.t('(RAL5024) & 3x Pure White (RAL9010)'), preview: hullColor16 },
            { value: 4, label: this.props.t('Light Grey'), description: this.props.t('(RAL 7035) & 3 x Pure White (RAL 9010) integrated Gelcoat Water Lines'), preview: hullColor14 },
            { value: 5, label: this.props.t('Black Grey'), description: this.props.t('(RAL 7021) & 3 x Pure White (RAL 9010) integrated Gelcoat Water Lines'), preview: hullColor15 }
        ];

        this.BowSpritOptions = [
            { value: 2, label: this.props.t('Standard GRP cowl in hull colour') },
            { value: 6, label: this.props.t('Carbon fibre bowsprit in hull colour') },
            { value: 4, label: this.props.t('Carbon fibre bowsprit  clear coated') }
        ];

        this.HullTreatmentOptions = [
            { value: 1, label: this.props.t('White') },
            { value: 2, label: this.props.t('Black (optional)') },
            { value: 3, label: this.props.t('Copper (optional)') }
        ];

        this.DeckOptions = [
            { value: 1, label: this.props.t('Genuine teak with black caulkings') },
            { value: 2, label: this.props.t('Flexiteek with grey stripes') }
        ];

        this.SprayhoodOptions = [
            { value: 1, label: this.props.t('Without'), thumbnail: sprayhood1 },
            { value: 2, label: this.props.t('Dark grey'), thumbnail: sprayhood2 },
            { value: 3, label: this.props.t('Taupe'), thumbnail: sprayhood3 },
            { value: 4, label: this.props.t('Captains blue'), thumbnail: sprayhood4 },
            { value: 5, label: this.props.t('Silver grey'), thumbnail: sprayhood5 }
        ];

        this.BoomCoverOptions = this.SprayhoodOptions;

        this.WheelOptions = [
            { value: 1, label: this.props.t('Standard Black GRP wheel') },
            { value: 2, label: this.props.t('Optional White GRP wheel') }
        ];

        this.MastAndBoomOptions = [
            { value: 1, label: this.props.t('Standard silver anodized aluminum') },
            { value: 2, label: this.props.t('Optional white carbon mast') },
            { value: 3, label: this.props.t('Optional black carbon mast') },
            { value: 4, label: this.props.t('Optional clear coated carbon mast') }
        ];

        this.VeneerOptions = [
            { value: 1, label: this.props.t('Nordic oak (standard)'), thumbnail: veneer1 },
            { value: 2, label: this.props.t('Modern teak (optional)'), thumbnail: veneer2 }
        ];

        this.FloorboardOptions = [
            { value: 1, label: this.props.t('Teak laminate (standard)'), thumbnail: laminate1 },
            { value: 2, label: this.props.t('Walnut laminate (optional)'), thumbnail: laminate2 },
            { value: 3, label: this.props.t('Teak with inlay stripes / holly (optional)'), thumbnail: laminate3 }
        ];

        this.WorktopOptions = [
            { value: 1, label: this.props.t('Worktop in Camoan white Corian'), thumbnail: galley1 },
            { value: 2, label: this.props.t('Worktop in black quartz Corian'), thumbnail: galley2 }
        ];

        this.FabricOptions = [
            { value: 1, label: this.props.t('Just Fleckless – 01 Nature'), thumbnail: fabric1 },
            { value: 2, label: this.props.t('Just Fleckless – 05 Camel'), thumbnail: fabric2 },
            { value: 3, label: this.props.t('Just Fleckless – 10 Navy'), thumbnail: fabric3 },
            { value: 4, label: this.props.t('Just Fleckless – 403 Bambus'), thumbnail: fabric4 },
            { value: 5, label: this.props.t('Just Fleckless – 710 Moon Grey'), thumbnail: fabric5 },
            { value: 6, label: this.props.t('Just Fleckless – 750 Olive Grey'), thumbnail: fabric6 },
            { value: 7, label: this.props.t('Alsace Blue'), thumbnail: fabric7 },
            { value: 8, label: this.props.t('Alsace Ivory'), thumbnail: fabric8 },
            { value: 9, label: this.props.t('Alsace Sand'), thumbnail: fabric9 },
            { value: 10, label: this.props.t('Nubilux 709 Argent'), thumbnail: fabric10 }
        ];

        this.HandrailOptions = [
            { value: 1, label: this.props.t('No handrails') },
            { value: 2, label: this.props.t('Wooden laminated') },
            { value: 3, label: this.props.t('Stainless steel') }
        ];

        this.LayoutOptions = [
            { value: 1, label: this.props.t('Standard') },
            { value: 2, label: this.props.t('Alternative') }
        ];

        this.state = Object.assign(this.state, {
            boat: "XP55",
            exterior: {
                HullColour: this.HullColourOptions[0],
                BowSprit: this.BowSpritOptions[0],
                HullTreatment: this.HullTreatmentOptions[0],
                Deck: this.DeckOptions[0],
                TeakOnSideDecks: { value: 1, label: 'false' },
                TeakOnCoachroof: { value: 1, label: 'false' },
                SprayHood: this.SprayhoodOptions[0],
                Wheel: this.WheelOptions[0],
                MastAndBoom: this.MastAndBoomOptions[0],
                BoomCover: this.BoomCoverOptions[0]
            },
            interior: {
                Veneer:  this.VeneerOptions[0],
                Floorboard: this.FloorboardOptions[0],
                Worktop: this.WorktopOptions[0],
                Fabric: this.FabricOptions[0],
                Handrail: this.HandrailOptions[0],
                Layout: this.LayoutOptions[0],
                BerthInfill: { value: 1, label: 'false' },
                FabricCabins: this.FabricOptions[0],
                AftCabinShelving: { value: 1, label: 'false' },
                SeaBerths: { value: 1, label: 'false' },
                Mast: this.MastAndBoomOptions[0]
            }
        });

        this.steps = [
            { name: this.props.t('Hull colourways'), url: '/xp55/hull' },
            { name: this.props.t('Bowsprit'), url: '/xp55/bowsprit' },
            { name: this.props.t('Hull treatment'), url: '/xp55/hulltreatment' },
            { name: this.props.t('Deck'), url: '/xp55/deck' },
            { name: this.props.t('Bathing platform'), url: '/xp55/bathingplatform' },
            { name: this.props.t('Boat name'), url: '/xp55/transom' },
            { name: this.props.t('Mast and boom'), url: '/xp55/mast' },
            { name: this.props.t('Wheels'), url: '/xp55/wheel' },
            { name: this.props.t('Sprayhood & Boom Cover'), url: '/xp55/sprayhood' },

            { name: this.props.t('Interior surfaces'), url: '/xp55/surfaces' },
            { name: this.props.t('Interior Fabric'), url: '/xp55/fabric' },
            { name: this.props.t('Galley'), url: '/xp55/galley' },
            { name: this.props.t('Owner\'s cabin'), url: '/xp55/ownerscabin' },
            { name: this.props.t('Aft cabins'), url: '/xp55/aftcabin' },
            
            { name: this.props.t('Summary'), url: '/xp55/summary' }
        ];


        this.handleHullConfigurationChange = this.handleHullConfigurationChange.bind(this);
    }

    handleHullConfigurationChange(newConfiguration) {
        let transom = this.state.transom;
        switch (newConfiguration.HullColour.value) {
            case 1:
                transom.Name.color = this.colorOptions[0];
                transom.Port.color = this.colorOptions[0];
                break;
            case 2:
                transom.Name.color = this.colorOptions[3];
                transom.Port.color = this.colorOptions[3];
                break;
            case 3:
                transom.Name.color = this.colorOptions[2];
                transom.Port.color = this.colorOptions[2];
                break;
            case 4:
            case 5:
            case 6:
                transom.Name.color = this.colorOptions[1];
                transom.Port.color = this.colorOptions[1];
                break;
            default:
                break;

        }

        super.handleTransomChange(transom);
        super.handleExteriorConfigurationChange(newConfiguration);
    }

    handleExteriorConfigurationChange(newConfiguration) {
        let interior = this.state.interior;
        interior.Mast = newConfiguration.MastAndBoom;

        super.handleInteriorConfigurationChange(interior);
        super.handleExteriorConfigurationChange(newConfiguration);
    }

    generateCode() {
        let data = [];
        data.push("xp55");

        data.push([]);
        let exterior = this.state.exterior;
        for (const key in exterior) {
            if (exterior.hasOwnProperty(key)) {
                let element = exterior[key].value;
                data[data.length - 1].push(element);
            }
        }

        data.push([]);
        data[data.length - 1].push([]);
        data[data.length - 1].push([]);

        let transom = this.state.transom;
        data[data.length - 1][0].push(transom.Name.value);
        data[data.length - 1][0].push(transom.Name.font.value);
        data[data.length - 1][0].push(transom.Name.size.value);
        data[data.length - 1][0].push(transom.Name.color.value);
        data[data.length - 1][0].push(transom.Name.horizontalOffset);
        data[data.length - 1][0].push(transom.Name.verticalOffset);

        data[data.length - 1][1].push(transom.Port.value);
        data[data.length - 1][1].push(transom.Port.font.value);
        data[data.length - 1][1].push(transom.Port.size.value);
        data[data.length - 1][1].push(transom.Port.color.value);
        data[data.length - 1][1].push(transom.Port.horizontalOffset);
        data[data.length - 1][1].push(transom.Port.verticalOffset);

        data.push([]);
        let interior = this.state.interior;
        for (const key in interior) {
            if (interior.hasOwnProperty(key)) {
                let element = interior[key].value;
                data[data.length - 1].push(element);
            }
        }
        
        var json = JSON.stringify(data);
        return btoa(json);
    }

    parseCode(code) {
        let json = JSON.parse(atob(code));

        if (json[0] !== 'xp55') {
            return;
        }

        let exterior = this.state.exterior;
        exterior.HullColour = this.HullColourOptions.find(v => v.value === json[1][0]) || this.HullColourOptions[0];
        exterior.BowSprit = this.BowSpritOptions.find(v => v.value === json[1][1]) || this.BowSpritOptions[0];
        exterior.HullTreatment = this.HullTreatmentOptions.find(v => v.value === json[1][2]) || this.HullTreatmentOptions[0];
        exterior.Deck = this.DeckOptions.find(v => v.value === json[1][3]) || this.DeckOptions[0];
        exterior.TeakOnSideDecks = { value: +json[1][4] || 1, label: '' };
        exterior.TeakOnCoachroof = { value: +json[1][5] || 1, label: '' };
        exterior.SprayHood = this.SprayhoodOptions.find(v => v.value === json[1][6]) || this.SprayhoodOptions[0];
        exterior.Wheel = this.WheelOptions.find(v => v.value === json[1][7]) || this.WheelOptions[0];
        exterior.MastAndBoom = this.MastAndBoomOptions.find(v => v.value === json[1][8]) || this.MastAndBoomOptions[0];
        exterior.BoomCover = this.BoomCoverOptions.find(v => v.value === json[1][9]) || this.BoomCoverOptions[0];

        let transom = this.state.transom;
        transom.Name.value = json[2][0][0] || '';
        transom.Name.font = this.fontOptions.find(v => v.value === json[2][0][1]) || this.fontOptions[0];
        transom.Name.size = this.sizeOptions.find(v => v.value === json[2][0][2]) || this.sizeOptions[0];
        transom.Name.color = this.colorOptions.find(v => v.value === json[2][0][3]) || this.colorOptions[0];
        transom.Name.horizontalOffset = +json[2][0][4] || 1;
        transom.Name.verticalOffset = +json[2][0][5] || 1;

        transom.Port.value = json[2][1][0] || '';
        transom.Port.font = this.fontOptions.find(v => v.value === json[2][1][1]) || this.fontOptions[0];
        transom.Port.size = this.sizeOptions.find(v => v.value === json[2][1][2]) || this.sizeOptions[0];
        transom.Port.color = this.colorOptions.find(v => v.value === json[2][1][3]) || this.colorOptions[0];
        transom.Port.horizontalOffset = +json[2][1][4] || 1;
        transom.Port.verticalOffset = +json[2][1][5] || 1;
        
        let interior = this.state.interior;
        interior.Veneer = this.VeneerOptions.find(v => v.value === json[3][0]) || this.VeneerOptions[0];
        interior.Floorboard = this.FloorboardOptions.find(v => v.value === json[3][1]) || this.FloorboardOptions[0];
        interior.Worktop = this.WorktopOptions.find(v => v.value === json[3][2]) || this.WorktopOptions[0];
        interior.Fabric = this.FabricOptions.find(v => v.value === json[3][3]) || this.FabricOptions[0];
        interior.Handrail = this.HandrailOptions.find(v => v.value === json[3][4]) || this.HandrailOptions[0];
        interior.Layout = this.LayoutOptions.find(v => v.value === json[3][5]) || this.LayoutOptions[0];
        interior.BerthInfill = { value: +json[3][6] || 1, label: '' };
        interior.FabricCabins = this.FabricOptions.find(v => v.value === json[3][7]) || this.FabricOptions[0];
        interior.AftCabinShelving = { value: +json[3][8] || 1, label: '' };
        interior.SeaBerths = { value: +json[3][9] || 1, label: '' };
        interior.Mast = exterior.MastAndBoom;
        
        this.setState(this.state);
    }


    renderSteps() {
        return (
            <Switch location={this.props.location}>
                <Route exact path="/xp55" render={() => <Redirect to="/xp55/hull" />} />

                <Route path="/xp55/hull" render={(props) => <XP55Hull {...props} onChange={this.handleHullConfigurationChange} onCodeSubmitted={this.parseCode} configuration={this.state.exterior} transom={this.state.transom} hullColourOptions={this.HullColourOptions} />} />
                <Route path="/xp55/bowsprit" render={(props) => <XP55BowSprit {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} bowSpritOptions={this.BowSpritOptions} />} />
                <Route path="/xp55/hulltreatment" render={(props) => <XP55HullTreatment {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} transom={this.state.transom} hullTreatmentOptions={this.HullTreatmentOptions} />} />
                <Route path="/xp55/transom" render={(props) => <XP55Transom {...props} onChange={this.handleTransomChange} configuration={this.state.exterior} transom={this.state.transom} fontOptions={this.fontOptions} sizeOptions={this.sizeOptions} colorOptions={this.colorOptions} />} />
                <Route path="/xp55/deck" render={(props) => <XP55Deck {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} transom={this.state.transom} deckOptions={this.DeckOptions} />} />
                <Route path="/xp55/bathingplatform" render={(props) => <XP55BathingPlatform {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} />} />
                <Route path="/xp55/sprayhood" render={(props) => <XP55Sprayhood {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} transom={this.state.transom} sprayhoodOptions={this.SprayhoodOptions} boomCoverOptions={this.BoomCoverOptions} />} />
                <Route path="/xp55/wheel" render={(props) => <XP55Wheel {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} wheelOptions={this.WheelOptions} />} />
                <Route path="/xp55/mast" render={(props) => <XP55Mast {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} transom={this.state.transom} mastAndBoomOptions={this.MastAndBoomOptions} />} />

                <Route path="/xp55/surfaces" render={(props) => <XP55Interior {...props} onChange={this.handleInteriorConfigurationChange} configuration={this.state.interior} veneerOptions={this.VeneerOptions} floorboardOptions={this.FloorboardOptions} />} />
                <Route path="/xp55/fabric" render={(props) => <XP55Fabric {...props} onChange={this.handleInteriorConfigurationChange} configuration={this.state.interior} fabricOptions={this.FabricOptions} handrailOptions={this.HandrailOptions} />} />
                <Route path="/xp55/galley" render={(props) => <XP55Galley {...props} onChange={this.handleInteriorConfigurationChange} configuration={this.state.interior} worktopOptions={this.WorktopOptions} layoutOptions={this.LayoutOptions} />} />
                <Route path="/xp55/aftcabin" render={(props) => <XP55AftCabin {...props} onChange={this.handleInteriorConfigurationChange} configuration={this.state.interior} />} />
                <Route path="/xp55/ownerscabin" render={(props) => <XP55OwnersCabin {...props} onChange={this.handleInteriorConfigurationChange} fabricOptions={this.FabricOptions} configuration={this.state.interior} />} />

                <Route path="/xp55/summary" render={(props) => <XP55Summary {...props} country={this.state.country} countries={this.state.countries} code={this.generateCode()} configuration={{ exterior: this.state.exterior, interior: this.state.interior, transom: this.state.transom }} />} />
            </Switch>
        );
    }
}

export default withTranslation()(XP55Container);


// WEBPACK FOOTER //
// ./src/XP55/XP55Container.js